const SOURCE_CAMPAIGN_MANAGER = 6;

class BuilderCtrl {

    constructor($scope, $routeParams, $rootScope, $timeout, $location, $builderService, $feedService, CONTENT_TYPE, ApiService, Notification, EVENTS, $interval, SERVICE_LOCATIONS) {
		
        this.$scope = $scope;
        this.$rootScope = $rootScope;
        this.CONTENT_TYPE = CONTENT_TYPE;
        this.ApiService = ApiService;
        this.Notification = Notification;
        this.$timeout = $timeout;
        this.$location = $location;
        this.EVENTS = EVENTS;
        this.$builderService = $builderService;
        this.$feedService = $feedService;
        this.SERVICE_LOCATIONS = SERVICE_LOCATIONS;

        $scope.accountId = $routeParams.accountId;
        $scope.advertiserId = $routeParams.advertiserId;
        $scope.campaignId = $routeParams.campaignId;
        $scope.creativeId = $routeParams.creativeId;

        $scope.isSaving = false;

        $scope.view = 'designer';
		$scope.adunit = null;
		$scope.widgets = {};
        $scope.selectedFolder = null;
        $scope.selectedEntity = null;
        $scope.activeTimelines = [];
        $scope.selectedTimeline = null;        
        $scope.selectedAnim = null;

        $scope.activeScrollTriggerConfigs = [];

        $scope.assetTypes = ["image/", "video/", "application/octet-stream", "application/font-woff"];
        $scope.workspaceOffset = {
            top: 0,
            left: 0
        };

        $scope.showFonts = false;

        $scope.expanded = {};
        window.REFLOW_DYNAMIC = {};

        $scope.selectTimeline = (a) => this.selectTimeline.call(this, a);
        $scope.hideTimeline = () => this.hideTimeline.call(this);
        $scope.hideFonts = () => this.hideFonts.call(this);
        $scope.isSelected = this.isSelected.bind(this);
        $scope.isExpanded = this.isExpanded.bind(this);
        $scope.toggleExpanded = this.toggleExpanded.bind(this);
        $scope.expandAll = this.expandAll.bind(this);
        $scope.save = this.save.bind(this);
        $scope.layoutCanvases = this.layoutCanvases.bind(this);
        $scope.undo = this.undo.bind(this);
        $scope.originalAdunit = null;
        $scope.isDirty = false;
        $scope.undoBuffer = [];

        this.loadWidgets();

    	$scope.templateUrl = "propertiesPopoverTemplate.html";

        /*Store the state of the ad-unit every 60 seconds. This will be cleared on save, when exiting the unit using the close button
        and declining to load the previous unit on re-opening of the creative. */
        $scope.autoSaveInterval = $interval(() => {
            if(!!this.$scope.adunit && $scope.isDirty) {
                localStorage.setItem(this.$scope.creativeId, JSON.stringify(this.$scope.adunit));    
            }
        }, 60000);

        $scope.$watch('addingLayer', (newVal, oldVal) => {
            if(newVal) {
                this.addToUndoBuffer($scope, $scope.previousUnit);
            }
        })

        $scope.$watch('adunit', (newVal, oldVal) => {

            $scope.previousUnit = oldVal;

            if(!$scope.isDirty && !!oldVal && (newVal !== oldVal) ) {
                let d = this.diffObject(newVal, $scope.originalAdunit, ["$$hashKey", "selected"]);
                if(Object.keys(d).length && !$scope.isUndoing) {
                    $scope.isDirty = true;
                }
            }
            if(!!oldVal && !$scope.isUndoing && !$scope.isDragging && !$scope.addingLayer) {
                let d = this.diffObject(newVal, oldVal, ["$$hashKey", "selected"]);
                if(Object.keys(d).length) {
                    this.addToUndoBuffer($scope, oldVal);
                }
            }
            else if($scope.isUndoing) {
                $scope.isUndoing = false;
            }

        }, true);

        $timeout(() => {
            this.loadCampaign();

            if(!!$scope.creativeId && !!localStorage.getItem(this.$scope.creativeId)) {
                //@TODO replace with styled modals/alerts?
                if(window.confirm("An unsaved version of this creative exists, would you like to use this version instead?")) {
                    $scope.adunit = JSON.parse(localStorage.getItem(this.$scope.creativeId));
                    $scope.originalAdunit = JSON.parse(localStorage.getItem(this.$scope.creativeId));
                    $scope.selectedEntity = $scope.adunit;                                 
                    $scope.expandAll();
                }
                else {
                    localStorage.removeItem(this.$scope.creativeId);
                    if(!!this.$scope.creativeId) {
                        this.getAdunit();
                    }
                    else {
                        $rootScope.$broadcast('template-selector-show');
                    }

                }
            }
            else if("undefined" !== typeof $scope.creativeId ) {
                this.getAdunit();
            }
            else if($scope.adunit == null) {
                $rootScope.$broadcast('template-selector-show');
            }
        }, 0);

        $scope.$on("$locationChangeStart", () => {
            $interval.cancel($scope.autoSaveInterval);
        }); 

        $scope.$watch("adunit.useFeed", () => { 
            if(!!$scope.campaign) {
                this.loadFeed();
            }
        });

        $scope.$watch("adunit.numFeedItems", (cur, prev) => {
            if(!!cur && !!prev && cur !== prev) {
                this.loadFeed();
            }
        });

        $scope.$watch("isDragging", (newVal, oldVal) => {
            if(oldVal != typeof "undefined" && (newVal && !oldVal)){
                this.addToUndoBuffer($scope, $scope.adunit);
            }
        });

        $scope.$watch("isUndoing", (newVal, oldVal) => {
            if(!newVal && $scope.isDirty) {
                let d = this.diffObject(newVal, $scope.originalAdunit, ["$$hashKey", "selected"]);
                $scope.isDirty = Object.keys(d).length > 0;
            }
        })
        

        $scope.selectAdunit = () => {
            $scope.selectedEntity = $scope.adunit;            
            $scope.$emit("select-builder");
        };

    	$scope.selectCanvas = (canvas) => {
    		$scope.$emit("select-canvas", canvas);
    	};

    	$scope.selectLayer = (layer) => {
    		$scope.$emit("select-layer", layer);
    	};

        $scope.setView = (view) => {
            $scope.view = view;
        };

        $scope.preview = (rootCanvas) => {

            if(!!rootCanvas) {
                let tempUnit = JSON.parse(JSON.stringify($scope.adunit));
                tempUnit.deviceroots.desktop = tempUnit.deviceroots[rootCanvas];
                $rootScope.$emit("ad-preview", tempUnit);
            }
            else {
               $rootScope.$emit("ad-preview", $scope.adunit); 
            }

        };

        $scope.close = () => {
            if($scope.isDirty) {
                if(window.confirm("Are you sure you want to close this creative?")) {
                    this.toCreativesScreen($scope, $location, $interval);
                }
            }
            else {
                this.toCreativesScreen($scope, $location, $interval);
            }
        };

        $scope.copyCurrentEntity = this.copyCurrentEntity.bind(this);
        $scope.deleteSelectedEntity = this.deleteSelectedEntity.bind(this);

        $scope.$on("select-template", (ev, template) => {
            let adunit = adunit = JSON.parse(JSON.stringify(template.def));
            let deviceRoots = adunit.deviceroots;

            var layerIds = {

            }

            //reassign ids
            $.each(adunit.canvases, (ix, c) => {
                c.visibleInDesigner = true;

                let oldId = c.id;
                c.id = ObjectId();

                if(deviceRoots.desktop === oldId) {
                    adunit.deviceroots.desktop = c.id;
                } 
                
                if(deviceRoots.mobile === oldId) {
                    adunit.deviceroots.mobile = c.id;
                }

                if(deviceRoots.tablet === oldId) {
                    adunit.deviceroots.tablet = c.id;
                }

                $.each(c.layers, (ix, l) => {
                    var oldLayerId = l.id;
                    l.id = ObjectId();
                    layerIds = oldLayerId;

                });
            });

            adunit._id = ObjectId();
            $scope.adunit = adunit;

            $rootScope.$emit('template-selector-hide');
            $scope.selectedEntity = $scope.adunit;
            $scope.expandAll();
            $scope.originalAdunit = JSON.parse(JSON.stringify(this.$scope.adunit));   
        });
        
        $rootScope.$on("select-builder", () => $scope.selectedEntity = $scope.adunit );
        $rootScope.$on("select-canvas", (ev, entity) => { $scope.selectedEntity = entity });
        $rootScope.$on("add-canvas", (ev, entity) => { this.expand(entity) });
        $rootScope.$on("select-layer", (ev, entity) => $scope.selectedEntity = entity );
        $rootScope.$on("select-timeline", (ev, args) => this.selectTimeline(args) );
        $rootScope.$on("deselect-timeline", (ev, timeline) => this.deselectTimeline(timeline) );
        $rootScope.$on("hide-timeline", (ev, timeline) => this.hideTimeline(timeline) );
        $rootScope.$on("select-anim", (ev, args) => this.selectAnim(args) );
        $rootScope.$on('show-scroll-trigger-config', (ev, args) => this.showScrollTriggerConfig(args));

        $scope.keyListener = $(document).keydown((ev) => {

            if(this.isInputSelected()) {
                return;
            }

            if(ev.ctrl || ev.metaKey) {
                switch(ev.keyCode) {
                    case 83:
                        ev.preventDefault();
                        this.save();
                        break;
                    case 67: 
                        ev.preventDefault();
                        switch($scope.selectedEntity.contentType) {
                            case "x-reflow/layer":
                            case "x-reflow/canvas":
                                $scope.entityToCopy = JSON.parse(JSON.stringify($scope.selectedEntity));
                                $scope.entityToCut = undefined;
                                break;
                        }
                        break;
                    case 88:
                        switch($scope.selectedEntity.contentType) {
                            case "x-reflow/layer":
                            case "x-reflow/canvas":
                                $scope.entityToCut = JSON.parse(JSON.stringify($scope.selectedEntity));
                                $scope.entityToCopy = undefined;
                                break;
                        }
                        break;
                    case 86: 
                        ev.preventDefault();
                        if(!!$scope.entityToCopy) {
                            this.copyCurrentEntity($scope.entityToCopy);
                        }
                        else if(!!$scope.entityToCut) {
                            this.copyCurrentEntity($scope.entityToCut);
                            if($scope.entityToCut.contentType === "x-reflow/layer" ) {
                                this.deleteLayer($scope.entityToCut)
                            }
                            else if($scope.entityToCut.contentType === "x-reflow/canvas") {
                                this.deleteCanvas($scope.entityToCut);
                            }
                        }
                        break;
                    case 90:
                        ev.preventDefault();
                        if($scope.undoBuffer.length > 0) {
                            this.undo(0);
                        }

                    // case 
                }
            }
        });

        /* Called on dragging of workspace, if dragging has started copy the current selected entity (as this will be deselected)
           When dragging of the workspace has completed then retreieve the previously selected entity and re-select this. 
           The isSelected function called by each list item's ng-change checks for object equality so we can't just use the copy created earlier.
        */

        $rootScope.$on("draggingWorkspace", (ev, args) => {

            //If an editable element then just return and don't worry about reselecting elements
            if(this.isInputSelected()) {
                return;
            }

            if(args) { 
                $scope.previouslySelected = JSON.parse(JSON.stringify($scope.selectedEntity));
            }
            else { 
                switch($scope.previouslySelected.contentType) {
                    case "x-reflow/layer":
                        let layer;
                        $.each($scope.adunit.canvases, (index, c) => {
                            $.each(c.layers, (index, l) => {
                                if(l.id == $scope.previouslySelected.id) {
                                    layer = l;
                                    return false;
                                }
                            });
                            if(!!layer) { return false; }
                        });
                        $scope.selectLayer(layer);
                        break;
                    case "x-reflow/canvas":
                        let canvas;
                        $.each($scope.adunit.canvases, (index, c) => {
                            if(c.id === $scope.previouslySelected.id) {
                                canvas = c;
                                return false;
                            }
                        });
                        $scope.selectCanvas(canvas);
                        break;
                    case "x-reflow/adunit": 
                        $scope.selectAdunit();
                        break;
                }
            }
        });

        $rootScope.$on("delete-layer", (ev, args) => this.deleteLayer(args));
        $rootScope.$on("delete-canvas", (ev, args) => this.deleteCanvas(args));
        $rootScope.$on("show-fonts", () => this.showFonts());
        
        $rootScope.$on("dragging-layer", (ev, args) => {
            $scope.isDragging = args;
            $scope.$apply();
        })

        $rootScope.$on("adding-layer", (ev, args) => {
            //If layer is being added, set flag as we don't want to add to the undobuffer
            $scope.addingLayer = args;
        })
        
        $rootScope.droppables = [];

        $rootScope.pushDroppable = (el) => {
            $.each($rootScope.droppables, (ix, x) => {
                x.removeClass("drag-over");
            });
            $rootScope.droppables.unshift(el);
            $rootScope.droppables[0].addClass("drag-over");
        };

        $rootScope.popDroppable = () => {
            $rootScope.droppables.shift();
            if($rootScope.droppables.length > 0) {
                $rootScope.droppables[0].addClass("drag-over");
            }
        };

        //todo need to close scroll config when timeline itself is closed
        //can emit an event with the timeline and splice $scope.activeScrollTriggerConfigs
        $scope.hideScrollTriggerConfig = (index) => {    
            if(index > -1) {
                this.$scope.activeScrollTriggerConfigs.splice(index, 1)
            }
        }

        this.loadFeed();

    }

    toCreativesScreen($scope, $location, $interval) {
        $location.path("/account/" + $scope.accountId + "/" + $scope.advertiserId + "/campaign/" + $scope.campaignId + "/creatives");
        $interval.cancel($scope.autoSaveInterval);
        $scope.keyListener.off("keydown");
    }

    isSelected(entity) {
        return Object.is(entity, this.$scope.selectedEntity);
    }

    isExpanded(entity) {
        if(entity !== null) {
            let key = entity.contentType + ";" + (entity.id || entity._id);
            return !!this.$scope.expanded[key] ? "expanded" : "";
        }
        else {
            return "";
        }
    }

    expand(entity) {
        let key = entity.contentType + ";" + (entity.id || entity._id);
        this.$scope.expanded[key] = true;
    }

    toggleExpanded(entity) {
        let key = entity.contentType + ";" + (entity.id || entity._id);
        this.$scope.expanded[key] = !this.$scope.expanded[key];
    }

    expandAll() {
        this.$scope.toggleExpanded(this.$scope.adunit);
        $.each(this.$scope.adunit.canvases, (ix, canvas) => {
            this.$scope.toggleExpanded(canvas);                        
        });
    }

    loadCampaign() {
        this.ApiService.get(this.CONTENT_TYPE.CAMPAIGN, this.$scope.campaignId) 
            .then((response) => {
                this.$scope.campaign = response.data;
            }, (response) => console.error(response));
    }

    loadFeed() {

        window.REFLOW_DYNAMIC = { };

        if(!(this.$scope.adunit && this.$scope.adunit.useFeed)) {
            delete window.REFLOW_DYNAMIC;
            this.$rootScope.$broadcast("feed-updated");
            return;
        }
                
        if(("undefined" === typeof this.$scope.adunit.numFeedItems || this.$scope.adunit.numFeedItems === null) && !!this.$scope.campaign.features) {
            let numItems = _.find(this.$scope.campaign.features, (x) => x.type === "NUM");
            if(!!numItems) {
                this.$scope.adunit.numFeedItems = numItems.value;
            }
        }

        if(!!this.$scope.campaign.feedId) {
            this.ApiService.get(this.CONTENT_TYPE.FEED, this.$scope.campaign.feedId)
                .then( response => {
                    this.$scope.feed = response.data;

                    /* 
                    The feed fields from insight are not necessarily in the correct order so retreive them
                    from reflow instead for now.
                    */

                    this.$feedService.getFeedFields(this.$scope.campaign.feedId)
                        .then(response => {
                            window.REFLOW_DYNAMIC_FIELDS = response.data;
                        }, error => {
                            console.error(error);
                        });

                    let feed = this.$scope.feed;

                    $.get(this.SERVICE_LOCATIONS.CPM_API + "feed/" + feed.id  + "/items?perPage=" + this.$scope.adunit.numFeedItems + "&revision=" + feed.publishedRevision, (data) => {
                        window.REFLOW_DYNAMIC = { products: data.items };                                
                        this.$rootScope.$broadcast("feed-updated");
                    });
                }, (response) => console.error(response)
            );
        }

    }

    loadWidgets() {
        this.$builderService.getWidgets( (widgets) => {
            this.$scope.widgets = angular.copy(widgets);
            this.$rootScope.$emit("render");
        });
    }

    selectTimeline(args) {

        this.$scope.selectedTimeline = args.timeline;
        let existing = this.$scope.activeTimelines.find( (x) => x.timeline.id == args.timeline.id );

        if(!existing) {
            let canvas = this.$scope.adunit.canvases.find( (x) => x.id == args.canvas.id );
            this.$scope.activeTimelines.push({ canvas: canvas, timeline: args.timeline });
        }

    }

    deselectTimeline(timeline) {
        if(this.$scope.selectedTimeline != null && this.$scope.selectedTimeline.id == timeline.id) {
            this.$scope.selectedTimeline = null;
        }
    }

    hideTimeline(ix) {
        if("object" == typeof ix) {
            let existing = this.$scope.activeTimelines.findIndex( (x) => x.timeline.id == ix.id );
            if(existing >= 0) {
                this.$scope.activeTimelines.splice(existing, 1);
            }
            if(this.$scope.selectedTimeline != null && this.$scope.selectedTimeline.id == ix.id) {
                this.$scope.selectedTimeline = null;
            }
        }
        else {
            this.$scope.activeTimelines.splice(ix, 1);
        }
    }

    selectAnim(args) {
        this.$scope.selectedAnim = args.anim;
        if(args.anim.layerId != null) {
            let layer = args.canvas.layers.find( (x) => x.id == args.anim.layerId );
            this.$scope.$emit("select-layer", layer);
        }
    }

    showScrollTriggerConfig(args) {
        let index = this.$scope.activeScrollTriggerConfigs.findIndex( (x) => x.id == args.id );

        if(index > -1) {
            return;
        }
        
        this.$scope.activeScrollTriggerConfigs.push(args);
    }

    deleteSelectedEntity() {
        if(this.$scope.selectedEntity.contentType === "x-reflow/canvas") {
            this.deleteCanvas(this.$scope.selectedEntity);
        }
        else if(this.$scope.selectedEntity.contentType === "x-reflow/layer") {
            this.deleteLayer(this.$scope.selectedEntity);
        }
    }

    deleteLayer(layer) {
        this.$scope.adunit.canvases.forEach( (canvas) => {
            canvas.layers.forEach( (l, ix) => {
                if(l.id === layer.id) {
                    canvas.layers.splice(ix, 1);
                    //Also need to remove any potential animations there might be on any of the created timelines
                    if(!!canvas.timelines) {
                    canvas.timelines.forEach((t, ix) => {
                            t.animations.forEach((a, ix) => {
                                if(a.layerId === layer.id) {
                                    t.animations.splice(ix, 1);
                                }
                            });
                        });
                    }
                    this.$rootScope.$emit("select-builder");
                }
            });
        });
    }

    deleteCanvas(canvas) {
        let ix = this.$scope.adunit.canvases.indexOf(canvas);
        if(ix >= 0) {
            this.$scope.adunit.canvases.splice(ix, 1);
            this.$rootScope.$emit("select-builder");
            this.$rootScope.$emit("deselect-entity", canvas);
        }
    }

    showFonts() {
        this.$scope.showFonts = true;
    }

    hideFonts() {
        this.$scope.showFonts = false;
    }

    save() {

        this.$scope.isSaving = true;

        delete this.$scope.adunit["acl"];
        delete this.$scope.adunit["adserverType"];
        delete this.$scope.adunit["customScripts"];
        delete this.$scope.adunit["customStylesheets"];
        delete this.$scope.adunit["folderId"];
        delete this.$scope.adunit["tracking"];

        let specs = this.calculateSpecs();

        if("undefined" === typeof this.$scope.creativeId) {

            let creative = {
                campaignId: this.$scope.campaignId,
                name: this.$scope.adunit.name,
                def: this.$scope.adunit,
                urn: this.$scope.adunit._id,
                width: specs.width,
                height: specs.height,
                expandable: specs.expandable,
                source: SOURCE_CAMPAIGN_MANAGER
            };

            this.ApiService.create(this.CONTENT_TYPE.CREATIVE, creative)
                .then( (response) => {
                    this.$scope.creativeId = response.data.id;
                    this.$location.path("/account/" + this.$scope.accountId + "/" + this.$scope.advertiserId + "/campaign/" + this.$scope.campaignId + "/creatives/" + this.$scope.creativeId + "/builder");
                    this.$scope.$emit(this.EVENTS.SHOW_NOTIFICATION, {'message': 'Creative saved'});
                    this.$scope.isSaving = false;
                    localStorage.removeItem(this.$scope.creativeId);
                    // this.$scope.originalAdunit = $scope.
                    this.$scope.isDirty = false;
                    this.$scope.originalAdunit = JSON.parse(JSON.stringify(this.$scope.adunit));

                }, error => {
                    console.error(error);
                    this.$scope.isSaving = false;
                });
        }
        else {

            let creative = {
                id: this.$scope.creativeId,
                name: this.$scope.adunit.name,
                def: this.$scope.adunit,
                width: specs.width,
                height: specs.height,
                expandable: specs.expandable,
                source: SOURCE_CAMPAIGN_MANAGER
            };

            this.ApiService.update(this.CONTENT_TYPE.CREATIVE, creative)
                .then( (response) => {
                    
                    this.$scope.$emit(this.EVENTS.SHOW_NOTIFICATION, {'message': 'Creative saved'});
                    this.$scope.isSaving = false;
                    localStorage.removeItem(this.$scope.creativeId);
                    this.$scope.originalAdunit = JSON.parse(JSON.stringify(this.$scope.adunit));
                    this.$scope.isDirty = false;

                }, error => {
                    this.$scope.isSaving = false;
                });
        }

    }

    calculateSpecs() {

        let specs = {};
        var rootCanvas = this.$scope.adunit.deviceroots.desktop;
        if(!rootCanvas) {
            rootCanvas = this.$scope.adunit.deviceroots.mobile;
            if(!rootCanvas) {
                rootCanvas = this.$scope.adunit.deviceroots.tablet;
            }
        }

        var diagRoot = 0;
        var diagOther = 0;

        this.$scope.adunit.canvases.forEach( (c) => {
            if(c.id === rootCanvas) {
                specs.width = c.width;
                specs.height = c.height;
                diagRoot = diagOther = Math.sqrt(Math.pow(c.width, 2) + Math.pow(c.height, 2));
            }
            else {
                let diag = Math.sqrt(Math.pow(c.width, 2) + Math.pow(c.height, 2));
                diagOther = Math.max(diag, diagOther);
            }
        });

        specs.expandable = diagRoot !== diagOther;

        return specs;
    }

    copyCurrentEntity(currentEntity = this.$scope.selectedEntity) {
        
        //Angular's copy function should do the same thing (as used in load widgets)
        let copy = JSON.parse(JSON.stringify(currentEntity));
        copy.id = ObjectId();
        copy.name = "Copy of " + copy.name;
        let defaultTimeline = null;
        
        delete copy["$$hashKey"];

        let copyMap = {};

        if(this.$scope.selectedEntity.contentType === 'x-reflow/canvas') {

            copy.top += 50;
            copy.left += 50;

            var ix = 1;
            // replace the ids, keeping track of what was updated
            copy.layers.forEach( (x) => {
                let newId = ObjectId();
                copyMap[x.id] = newId;
                x.id = newId;
                ix++;
            });

            // fix up the timelines
            if(!!copy.timelines) {
                copy.timelines.forEach( (x, idx) => {

                    let oldId = x.id;
                    x.id = ObjectId();
                    
                    if(!!copy.defaultTimeline && oldId == copy.defaultTimeline) {
                        copy.defaultTimeline = x.id
                    }
                    x.animations.forEach( (y) => {
                        y.layerId = copyMap[y.layerId];
                    });
                });
            }

            // fix up the behaviours on each layer to point to new ones
            copy.layers.forEach( (x) => {
                x.behaviours.forEach( (y) => {
                    if(!!copyMap[y.target]) {
                        y.target = copyMap[y.target];
                    }
                });
            });

            this.$scope.adunit.canvases.unshift(copy);
            this.$timeout( () => {
                this.$scope.$emit("select-canvas", copy);
            });
            

        }
        else if(this.$scope.selectedEntity.contentType === 'x-reflow/layer') {

            copy.top += 10;
            copy.left += 10;

            var didAdd = false;

            // find out which canvas we belong to
            this.$scope.adunit.canvases.forEach( (x) => {
                x.layers.forEach( (y) => {
                    if(y.id === this.$scope.selectedEntity.id && !didAdd) {
                        x.layers.unshift(copy);
                        didAdd = true;
                    }
                });
            });

            this.$timeout( () => {
                this.$scope.$emit("select-layer", copy);
            });

        }

    }

    layoutCanvases() {
        var lastLeft = 100;
        var lastTop = 100;
        var maxHeight = 0;

        $.each(this.$scope.adunit.canvases, (ix, canvas) => {

            canvas.left = lastLeft;
            canvas.top = lastTop;

            maxHeight = Math.max(maxHeight, canvas.height);

            lastLeft += canvas.width + 50;
            if(lastLeft > 1000) {
                lastLeft = 100;
                lastTop += maxHeight + 50;
            }

        });

    }

    getAdunit() {

        var lastLeft = 100;
        var lastTop = 100;
        var maxHeight = 0;

        this.ApiService.get(this.CONTENT_TYPE.CREATIVE, this.$scope.creativeId)
        .then((response) => {

            this.$scope.creative = response.data;
            this.$scope.adunit = this.$scope.creative.def;

            // fix up legacy creatives
            let assets = this.$scope.adunit.assets;
            if("undefined" === typeof this.$scope.adunit.templateVars) {
                this.$scope.adunit.templateVars = {};
            }

            if("undefined" === typeof this.$scope.adunit.colourSwatches) {
                this.$scope.adunit.colourSwatches = [ "#000000", "#FFFFFF" ];
            }

            if("undefined" !== typeof this.$scope.adunit.borderWidth && this.$scope.adunit.borderWidth === "1px") {
                this.$scope.adunit.borderWidth = 1;
            }

            this.$scope.adunit.contentType = "x-reflow/adunit";
            $.each(this.$scope.adunit.canvases, (ix, canvas) => {
                if("undefined" === typeof canvas.templateVars) {
                    canvas.templateVars = {};
                }
                if("undefined" === typeof canvas.top) {
                    canvas.top = lastLeft;
                }
                if("undefined" === typeof canvas.left) {
                    canvas.left = lastTop;
                }
                if("undefined" === typeof canvas.visibleInDesigner) {
                    canvas.visibleInDesigner = true;
                }

                maxHeight = Math.max(maxHeight, canvas.height);

                lastLeft += canvas.width + 50;
                if(lastLeft > 1000) {
                    lastLeft = 100;
                    lastTop += maxHeight + 50;
                }

                canvas.contentType = "x-reflow/canvas";
                $.each(canvas.layers, (ix, layer) => {

                    if("undefined" === typeof layer.templateVars) {
                        layer.templateVars = {};
                    }
                    layer.contentType = "x-reflow/layer";

                    let asset = assets[layer.assetId];
                    if(!!asset) {
                        
                        if("undefined" === typeof layer.maintainAspectRatio) {
                            layer.maintainAspectRatio = asset.contentType.startsWith("image") || asset.contentType.startsWith("video");
                        }

                        if(asset.contentType === "x-reflow-widget/text") {
                            
                            if("undefined" !== typeof layer.textContent) {
                                layer.src = layer.textContent;
                                layer.fontFamily = layer.textFont;
                                layer.fontSize = layer.textFontSize;
                                //textAlign - same
                                layer.colour = layer.textColor;
                                layer.bold = layer.textWeight;
                                layer.decoration = layer.textUnderline;
                                
                                let newWidget = this.$builderService.findWidget("text/plain");
                                layer.assetId = newWidget._id;
                                this.$scope.adunit.assets[newWidget._id] = newWidget;

                                delete layer.textContent;
                                delete layer.textFont;
                                delete layer.textFontSize;
                                delete layer.textColor;
                                delete layer.textWeight;
                                delete layer.textUnderline;
                            }
                        }
                        else if(asset.contentType === "x-reflow-widget/customhtml") {
                            let newWidget = this.$builderService.findWidget("text/html");
                            layer.assetId = newWidget._id;
                            this.$scope.adunit.assets[newWidget._id] = newWidget;
                            layer.src = layer.customHtml;
                            delete layer.customHtml;
                        }
                    }
                    
                });
            });

            this.$scope.selectedEntity = this.$scope.adunit;            
            this.$scope.expandAll();
            this.$scope.originalAdunit = JSON.parse(JSON.stringify(this.$scope.adunit));     

        }, (response) => {
            console.error(response);
            this.$scope.error = true;
        });
    }

    /* https://stackoverflow.com/questions/8572826/generic-deep-diff-between-two-objects 
       @TODO - Move to a service?
    */
    
    diffObject(obj1, obj2, excludedKeys) {
        let differences = {};

        Object.keys(obj1).forEach(prop => {
            if (obj1.hasOwnProperty(prop) && excludedKeys.indexOf(prop) == -1) {
                if (!obj2.hasOwnProperty(prop)) { differences[prop] = obj1[prop]; }
                else if (obj1[prop] === Object(obj1[prop])) {
                    let difference = this.diffObject(obj1[prop], obj2[prop], excludedKeys );
                    if (Object.keys(difference).length > 0) { differences[prop] = difference; }
                }
                else if (obj1[prop] !== obj2[prop]) {
                    if (obj1[prop] === undefined) {
                        differences[prop] = 'undefined';
                    }
                    if (obj1[prop] === null) {
                        differences[prop] = null;
                    }
                    else if (typeof obj1[prop] === 'function') {
                        differences[prop] = 'function';
                    }
                    else if (typeof obj1[prop] === 'object') {
                        differences[prop] = 'object';
                    } 
                    else {
                        differences[prop] = obj1[prop];
                    }
                }
           }
        });
        return differences;
    }

    addToUndoBuffer($scope, oldVal) {
        let ts = new Date();
        let entry = {
            ts: ts.getTime(),
            label: moment(ts).format("HH:mm:ss"),
            adunit: JSON.stringify(oldVal)
        };
        $scope.undoBuffer.unshift(entry);

    }

    cleanupTimelines(newUnit) {
        this.$scope.activeTimelines.forEach((ix, timeline) => {
            let unit = this.findTimeline(newUnit, timeline.id);
            if(!unit) {
                this.$scope.activeTimelines.splice(ix, 1);
            }
            else {
                this.$scope.activeTimelines[ix].timeline = timeline;
            }
        });
    }

    findTimeline(newUnit, timelineId) {
        let timeline = null;
        newUnit.canvases.forEach(c => {
            if(!!c.timelines) {
                c.timelines.forEach(t => {
                    if(t.id == timelineId) {
                        timeline = t;
                    }
                });
            }
        });
        return timeline;
    }

    updateSelectedEntity() {
        let contentType = this.$scope.selectedEntity.contentType; 
        if(contentType === "x-reflow/adunit") {
            if(!!this.$scope.selectedEntity  && this.$scope.adunit._id == this.$scope.selectedEntity._id) {
                this.$scope.selectedEntity = this.$scope.adunit;
            }
        }
        else if(contentType === "x-reflow/canvas") {
            this.$scope.adunit.canvases.forEach(canvas => {
                if(!!this.$scope.selectedEntity && canvas.id == this.$scope.selectedEntity.id) {
                    this.$scope.selectedEntity = canvas;
                }
            });
        }
        else if(contentType === "x-reflow/layer") {
            this.$scope.adunit.canvases.forEach(canvas => {
                canvas.layers.forEach(layer => {
                    if(!!this.$scope.selectedEntity && layer.id === this.$scope.selectedEntity.id) {
                        this.$scope.selectedEntity = layer;
                    }
                });
            });
        }

        this.$rootScope.$emit('updateSelectorDims', this.$scope.selectedEntity);
    }

    undo(undoIndex = 0) {
        this.$scope.isUndoing = true; 
        let entry = this.$scope.undoBuffer[undoIndex];
        this.$scope.undoBuffer.splice(0, undoIndex + 1);
        let lastAdunit = JSON.parse(entry.adunit);
        this.$scope.adunit = lastAdunit;
        this.cleanupTimelines(this.$scope.adunit);
        this.updateSelectedEntity();

    };

    isInputSelected() {
        return $(document.activeElement).attr("contentEditable") || $(document.activeElement).is("input") || $(document.activeElement).is("textarea");
    } 



}

angular.module("cpm")
	.controller("BuilderCtrl", ['$scope', '$routeParams', '$rootScope', '$timeout', '$location', '$builderService', '$feedService', 'CONTENT_TYPE', 'ApiService', 'Notification', 'EVENTS', '$interval', 'SERVICE_LOCATIONS', BuilderCtrl]);
	
